var render = function render(){var _vm=this,_c=_vm._self._c;return _c('BBadge',{attrs:{"variant":"light"}},[_c('span',{staticClass:"text-danger"},[_c('FrIcon',{attrs:{"outlined":"","name":"check"}})],1),_c('span',{staticClass:"badgeTitle"},[_vm._v(" "+_vm._s(_vm.$t(`autoAccess.access.reasons["${_vm.title}"]`))+" ")])])
}
var staticRenderFns = []

export { render, staticRenderFns }